import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.413A1.93 1.93 0 0 1 5 3h6a.97.97 0 0 1 .713.288Q12 3.575 12 4c0 .425-.096.52-.287.713A.97.97 0 0 1 11 5H5v14h14v-6a.97.97 0 0 1 .288-.713A.97.97 0 0 1 20 12a.97.97 0 0 1 .712.287Q21 12.575 21 13v6q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zM19 6.4 10.4 15a.95.95 0 0 1-.7.275A.95.95 0 0 1 9 15a.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7L17.6 5H15a.97.97 0 0 1-.713-.287A.97.97 0 0 1 14 4a.97.97 0 0 1 .287-.712A.97.97 0 0 1 15 3h5q.424 0 .712.288A.97.97 0 0 1 21 4v5a.97.97 0 0 1-.288.713A.97.97 0 0 1 20 10a.97.97 0 0 1-.712-.287A.97.97 0 0 1 19 9z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }